import domtoimage from 'dom-to-image'
import { saveAs } from 'file-saver'
import React from 'react'
import {
  Bar,
  BarChart,
  CartesianGrid,
  ResponsiveContainer,
  XAxis,
  YAxis,
} from 'recharts'

export default function Graph({ title, data, showBtn = true }) {
  function downloadPNG() {
    domtoimage
      .toBlob(document.getElementById('spotted_lanternfly_graph'))
      .then((blob) => saveAs(blob, `${title} Chart.png`))
  }

  if (data === null) return null
  const domain = data
    .map((d) => d.ms)
    .filter((d) => d > 0)
    .sort((a, b) => a - b)


  const graphData = [
    {stage: "Eggs inactive", range: [data[0].ms, data[1].ms]},
    {stage: "Eggs growing", range: [data[1].ms, data[2].ms]},
    {stage: "Instar 1", range: [data[2].ms, data[3].ms]},
    {stage: "Instar 2", range: [data[3].ms, data[4].ms]},
    {stage: "Instar 3", range: [data[4].ms, data[5].ms]},
    {stage: "Instar 4", range: [data[5].ms, data[6].ms]},
    {stage: "Adults", range: [data[6].ms, data[7].ms]}
  ];


  // RESET START TIME FOR LIFE STAGES NOT STARTED IN CURRENT YEAR
  for (let i = 0; i < graphData.length; i++) {
    if (graphData[i].range[0] > graphData[i].range[1]) {
      graphData[i].range[0] = graphData[i].range[1]
    }
  }
  //console.log('graphData',graphData)


  const xFormatter = (milliseconds) => new Date(milliseconds).toLocaleDateString();

  return (
    <div className="w-full" aria-hidden="true">
      <div className="flex items-center justify-between mb-6">
        <h2 className="inline-block text-lg font-semibold text-gray-600 sm:text-xl md:text-2xl">
          {title}
        </h2>

        {showBtn && (
          <div className="flex items-center justify-center rounded-md">
            <button
              type="button"
              aria-label="download graph in png format"
              onClick={downloadPNG}
              className="inline-flex items-center p-2 text-sm font-bold leading-4 text-white transition duration-150 ease-in-out border border-transparent rounded-md sm:px-3 sm:py-2 bg-secondary-800 hover:bg-secondary-700 focus:outline-none focus:border-secondary-900 focus:shadow-outline-secondary active:bg-secondary-900"
            >
              <svg
                className="-ml-0.5 mr-2 h-4 w-4 text-white"
                fill="none"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4"></path>
              </svg>
              <span className="hidden mr-1 sm:inline-block">Download </span>{' '}
              <span className="text-white">PNG</span>
            </button>
          </div>
        )}
      </div>

      <div id="spotted_lanternfly_graph">
        <ResponsiveContainer
          width="100%"
          height={350}
          id="spotted_lanternfly_graph"
        >
          <BarChart
            layout="vertical"
            width="100%"
            height={300}
            data={graphData}
            barCategoryGap={1}
            margin={{
              top: 5,
              right: 75,
              left: 75,
              bottom: 75
            }}
            className="px-6 py-6 mb-16 bg-white rounded-lg shadow-lg sm:mb-18 md:mb-20"
          >
            <CartesianGrid opacity={0.3} vertical={false} />
            <XAxis 
              axisLine={false}
              tickCount={9}
              style={{
                fontSize: "0.6rem",
              }}
              angle={-45}
              textAnchor="end"
              dataKey ="range" 
              type="number"
              tickFormatter={xFormatter}
              domain={domain}
              dy={10}
              
              />
            <YAxis 
            reversed 
            axisLine={false} 
            tickLine={false}
            tickCount={7}
            style={{
              fontSize: "0.6rem"
            }}
            type="category" 
            dataKey="stage" 
            label={{
              value: 'Spotted Lanternfly Progress',
              angle: -90,
              position: 'insideBottomLeft',
              offset: -50,
              dy: -40,
            }}/>
            <Bar dataKey="range" barSize={10} stroke="#522020" fill="#c45454" />
          </BarChart>
        </ResponsiveContainer >
      </div>
    </div>
  )
}